import { axiosBaseRequest, mapCodeParams } from 'api/helpers';
import { getCodeParamsUrl } from 'api/endpoints';

export const getCodeParamsRequest = (codeId) => axiosBaseRequest({
  url: getCodeParamsUrl,
  params: { code_id: codeId },
}).then(mapCodeParams);
